import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'
import { safeTranslates } from '../../../common/utils'

const prepareToSave = item => {
  const translates = safeTranslates(item.translates)
  return {
    ...item,
    name: item.name.trim(),
    image: item.image ? item.image : undefined,
    foodKindId: parseInt(item.foodKindId, 10),
    translates: Reflect.ownKeys(translates).length === 0 ? undefined : translates,
  }
}

export default ({ addIngredient, updateIngredient, history, resetDirty }) => {

  const [saving, setSaving] = useState(false)

  const onSave = useCallback(
    item => {
      setSaving(true)
      const result = prepareToSave(item)
      delete result.id
      return updateIngredient(item.id, result).then(() => {
        toast.success(`Ingredient '${result.name}' updated`, {
          position: toast.POSITION.TOP_RIGHT,
        })
        setSaving(false)
        resetDirty()
      }).catch(() => setSaving(false))
    },
    [resetDirty, updateIngredient],
  )

  const onAdd = useCallback(
    item => {
      setSaving(true)
      const result = prepareToSave(item)
      return addIngredient(result).then(newIngredient => {
        toast.success(`Ingredient '${result.name}' added`, {
          position: toast.POSITION.TOP_RIGHT,
        })
        setSaving(false)
        resetDirty()
        history.push(`/ingredients/${newIngredient.id}`)
      }).catch(() => setSaving(false))
    },
    [addIngredient, history, resetDirty],
  )
  return {
    onAdd,
    onSave,
    saving,
  }
}
